import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import LogInModal from 'flarum/forum/components/LogInModal';

export default class CommunityFooter extends Component {
  view() {
    const currentUser = app.session.user;
    const baseUrl = app.forum.attribute('baseUrl') || '';
    const currentRoute = m.route.get();

    // 只有在登录页且未登录时，才只显示底部备案信息
    const isLoginPage = currentRoute.includes('/mobile-register');
    if (isLoginPage && !currentUser) {
      return (
        <footer className="CommunityFooter CommunityFooter-login-only">
          <div className="CommunityFooter-bottom CommunityFooter-bottom-login-only">
            <p className="CommunityFooter-powered CommunityFooter-powered-login-only">
              {app.translator.trans('tf-custom-footer.forum.footer.powered-by')}
            </p>
            <div className="CommunityFooter-icp CommunityFooter-icp-login-only">
              <span>{app.translator.trans('tf-custom-footer.forum.footer.icp-number')}</span>
              <span className="CommunityFooter-icp-icon CommunityFooter-icp-icon-login-only">
                <img src={baseUrl + '/assets/images/icp.png'} alt="ICP Icon" />
              </span>
              <span>{app.translator.trans('tf-custom-footer.forum.footer.police-number')}</span>
            </div>
          </div>
        </footer>
      );
    }

    // 已登录时显示完整footer
    return (
      <footer className="CommunityFooter">
        <div className="CommunityFooter-container">
          {/* 左侧内容区域 */}
          <div className="CommunityFooter-left">
            <div className="CommunityFooter-title">
              <img src={baseUrl + '/assets/images/logo.png'} alt="Community Logo" />
            </div>
            <p className="CommunityFooter-description">
              {app.translator.trans('tf-custom-footer.forum.footer.description')}
            </p>
            <div className="CommunityFooter-right">
            <div className="CommunityFooter-section">
              <h3 className="CommunityFooter-section-title">
                {app.translator.trans('tf-custom-footer.forum.footer.quick-links')}:
              </h3>
              <ul className="CommunityFooter-links">
                <li>
                  <Link 
                    href={baseUrl}
                    onclick={this.handleLinkClick.bind(this)}
                  >
                    {app.translator.trans('tf-custom-footer.forum.footer.home')}
                  </Link>
                </li>
                <li>
                  <Link 
                    href={baseUrl + '/groups'}
                    onclick={this.handleLinkClick.bind(this)}
                  >
                    {app.translator.trans('tf-custom-footer.forum.footer.user-groups')}
                  </Link>
                </li>
                <li>
                  <Link 
                    href={baseUrl + '/weekly-quiz'}
                    onclick={this.handleLinkClick.bind(this)}
                  >
                    {app.translator.trans('tf-custom-footer.forum.footer.weekly-quiz')}
                  </Link>
                </li>
                <li>
                  <Link 
                    href={baseUrl + '/about'}
                    onclick={this.handleLinkClick.bind(this)}
                  >
                    {app.translator.trans('tf-custom-footer.forum.footer.about')}
                  </Link>
                </li>
              </ul>
            </div>
               {/* Legal */}
               <div className="CommunityFooter-section">
              <h3 className="CommunityFooter-section-title">
                {app.translator.trans('tf-custom-footer.forum.footer.legal')}:
              </h3>
              <ul className="CommunityFooter-links">
                <li>
                  <Link 
                    href={baseUrl + '/terms'}
                    onclick={this.handleLinkClick.bind(this)}
                  >
                    {app.translator.trans('tf-custom-footer.forum.footer.terms')}
                  </Link>
                </li>
                <li>
                  <Link 
                    href={baseUrl + '/privacy'}
                    onclick={this.handleLinkClick.bind(this)}
                  >
                    {app.translator.trans('tf-custom-footer.forum.footer.privacy')}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Personal Center */}
            {currentUser && (
              <div className="CommunityFooter-section">
                <h3 className="CommunityFooter-section-title">
                  {app.translator.trans('tf-custom-footer.forum.footer.personal-center')}:
                </h3>
                <ul className="CommunityFooter-links">
                  <li>
                    <Link 
                      href={app.route('user', { username: currentUser.username() })}
                      onclick={this.handleLinkClick.bind(this)}
                    >
                      {app.translator.trans('tf-custom-footer.forum.footer.my-profile')}
                    </Link>
                  </li>
                  <li>
                    <Link 
                      href={app.route('user', { username: currentUser.username() }) + '/posts'}
                      onclick={this.handleLinkClick.bind(this)}
                    >
                      {app.translator.trans('tf-custom-footer.forum.footer.my-posts')}
                    </Link>
                  </li>
                  <li>
                    <Link 
                      href={baseUrl + '/u/' + currentUser.username() + '/points'}
                      onclick={this.handleLinkClick.bind(this)}
                    >
                      {app.translator.trans('tf-custom-footer.forum.footer.my-points')}
                    </Link>
                  </li>
                </ul>
              </div>
            )}
            </div>
          </div>

          {/* 右侧链接区域 */}
          <div className="CommunityFooter-right">
            {/* Quick Links */}
            <div className="CommunityFooter-illustration">
              {/* 人群插图 - SVG占位符，用户可以根据需要替换 */}
              <img src={baseUrl + '/assets/images/footer.jpg'} alt="Community Illustration" /> 
            </div>
           

         
          </div>
        </div>

        {/* 底部备案信息 */}
        <div className="CommunityFooter-bottom">
        <p className="CommunityFooter-powered">
              {app.translator.trans('tf-custom-footer.forum.footer.powered-by')}
            </p>
          <div className="CommunityFooter-icp">
            <span>{app.translator.trans('tf-custom-footer.forum.footer.icp-number')}</span>
            <span className="CommunityFooter-icp-icon">
              <img src={baseUrl + '/assets/images/icp.png'} alt="ICP Icon" />
            </span>
            <span>{app.translator.trans('tf-custom-footer.forum.footer.police-number')}</span>
          </div>
        </div>
      </footer>
    );
  }

  /**
   * 处理链接点击事件
   * @param {Event} e - 点击事件对象
   */
  handleLinkClick(e) {
    // Link组件会自动处理SPA路由跳转
    // 可以在这里添加额外的逻辑，比如统计点击等
  }

  /**
   * 处理登录（未登录用户点击个人中心链接时）
   */
  handleLogin() {
    app.modal.show(LogInModal);
  }
}

